import { FC } from 'react'
import {
  DefaultImageContainer,
  NumberOfArt,
  OrderDetailContentContainer,
  // OrderDetailContentImage,
  OrderDetailContentLeftContent,
  OrderDetailContentName,
  // OrderDetailContentPrice,
  // OrderDetailContentRightContent,
} from '../order.styled'
import { OrderDetailContentImageProps } from '../order.types'
import { ReactComponent as DefaultImage } from '../../../assets/default_art_img.svg'

export const OrderDetailContent: FC<OrderDetailContentImageProps> = ({
  name,
  quantity,
  // unit_amount,
}) => {
  return (
    <OrderDetailContentContainer>
      <OrderDetailContentLeftContent>
        {/* Not implemented yet */}
        {/* <OrderDetailContentImage image={image} /> */}
        {/* <DefaultImageContainer>
          <DefaultImage />
        </DefaultImageContainer> */}
        <div>
          <OrderDetailContentName>{name}</OrderDetailContentName>
          {/* Not implemented yet */}
          {/* <NumberOfArt>Quantity: {quantity}</NumberOfArt> */}
        </div>
      </OrderDetailContentLeftContent>
      {/* Not implemented yet */}
      {/* <OrderDetailContentRightContent>
        <OrderDetailContentPrice>{unit_amount}</OrderDetailContentPrice>
      </OrderDetailContentRightContent> */}
    </OrderDetailContentContainer>
  )
}
